/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage } from 'react-intl'; 
import "./videomodal.scss";

class ModalExample extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div>
        <button className={this.props.buttonClassName} onClick={this.toggle}>{this.props.buttonLabel}</button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className="video-modal">
          <ModalBody className="p-1 video-modal-body">
            {this.props.children}
          </ModalBody>
          <ModalFooter className="video-modal-footer pr-3 pb-3 pt-1">
            <h3 className="text-light mr-auto">{this.props.title}</h3>
            <Button color="danger" onClick={this.toggle}><FormattedMessage id="close"/></Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ModalExample;


// WEBPACK FOOTER //
// ./src/components/VideoModal/index.js